import React from 'react';
import { PriceString, Tooltip } from '@fourthwall/components';
import * as S from './VariantPrice.styled';
export const VariantPrice = ({ price, oldPrice, tooltip }) => (React.createElement(Tooltip, { reference: React.createElement(S.Container, null,
        React.createElement(S.OldPriceContainer, null,
            React.createElement(PriceString, { value: oldPrice.value })),
        React.createElement("div", null,
            React.createElement(PriceString, { value: price.value }))) }, tooltip));
